<template>
<div class="container commentdetail" v-wechat-title="title">
  <Scroller :is-refresh-data.sync="refresh"
            :is-loading-data.sync="loading"
            :is-finished-data.sync="finished"
            :no-data-text-data.sync="noDataText"
            :is-disabled-data="disabled"
            @on-infinite="onInfinite"
  >
    <div class="maininfo" v-if="commentinfo.commentinfo">
      <div class="swiper-container" id="pro_pic" style="height: auto">
          <div style="position:relative;height: 3.75rem;
    width: 100%;
    background: #101010;" v-show="isVideoImgs">
              <video
              @click="playFn"
                style="width:100%;height:100%;"
                class="videofile"
                id="videofile"
                :poster="commentinfo.commentinfo.video_img_url"
                :src="commentinfo.commentinfo.video_play_url"
                webkit-playsinline="true"
                playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="allow"
                preload="true"
              >
                <source  :src="commentinfo.commentinfo.video_play_url" type="video/mp4" />
                您的浏览器不支持 video 标签。
              </video>
              <img style="position: absolute;left: 45%;top: 45%;
              width: 0.5rem;height: 0.5rem" @click="playFn" v-if="!isfullscreen" src="/static/images/community/video.png">
          </div>
          <div v-show="!isVideoImgs">
        <swiper v-if="bannerList && bannerList.length > 0"  class="swiper_height" :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) of bannerList" :key="index">
            <img v-lazy="item" @click="preview(index)"/>
          </swiper-slide>
        </swiper>
        <div id="proSwiperPagination" class="swiper-pagination swiper-pagination-fraction"
             v-if="bannerList && bannerList.length > 0">
          <div class="pro_page">
            <span class="swiper-pagination-current">{{activeIndex+1}}</span><span
            class="swiper-pagination-split">/</span><span class="swiper-pagination-total">{{bannerList.length}}</span>
          </div>
        </div>
        </div>
        <div class="swiper_bottom_div" v-if="commentinfo.commentinfo.video_play_url!='' && (bannerList && bannerList.length > 0)">
          <span @click="playTab(0)" :class="playShow?'span_btnSelect':'span_btn'">
            <van-icon :color="playShow ? '#ffffff' : '#353535'" size="0.11rem" :name="!isfullscreen?'play':'pause'" />视频</span>
          <span @click="playTab(1)"  :class="!playShow?'span_btnSelect':'span_btn'">图片</span>
        </div>
      </div>
        <div class="pro_comment_item">
          <div class="comment_head_info">
            <div class="sj" v-if="$route.query.goodcomment != 1">
              <van-rate v-model="commentinfo.commentinfo.itemscore" :size="12" void-color="#eeeeee" void-icon="star" color="#FFCD07" readonly />
            </div>
            <div class="report" v-if="$route.query.goodcomment != 1" @click="report">
              <img src="../../assets/images/report.png"/>举报
            </div>
            <div class="img">
              <img v-if="commentinfo.commentinfo.head" :src="commentinfo.commentinfo.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}"/>
              <img v-if="!commentinfo.commentinfo.head" :src="errorHeadImg"/>
            </div>
            <div class="info">
              <div class="name">
                {{commentinfo.commentinfo.smallname}}
                <img v-if="commentinfo.commentinfo.vip_level" :src="`/static/images/vipIcon/l${commentinfo.commentinfo.vip_level}.png`"/>
              </div>
              <div class="time">{{commentinfo.commentinfo.time}} {{$route.query.goodcomment != 1 ? ('订单来源：' + commentinfo.commentinfo.order_from) : ''}}</div>
            </div>
          </div>
          <div class="comment_content_info">
            <div class="comment_txt">
              <span class="color-FC0324 f10 isfeedback" v-if="commentinfo.commentinfo.isfeedback">&nbsp;试用反馈&nbsp;</span>{{commentinfo.commentinfo.content}}
            </div>
          </div>
        </div>
    </div>
    <div class="commentProduct" v-if="commentinfo.showbuy == 1 && $route.query.showbuy != 0 && commentinfo.iteminfo && commentinfo.iteminfo.item_base_id">
      <div class="left">
        <img v-lazy="commentinfo.iteminfo.img_path">
        <p>{{commentinfo.iteminfo.name.length > 10 ? commentinfo.iteminfo.name.slice(0, 10) + '...' : commentinfo.iteminfo.name}}</p>
        <i>{{commentinfo.iteminfo.spec}}</i>
      </div>
      <div class="right" @click="goPay">
        <!--<img src="../../assets/images/jt8.png">-->
        <p class="color-FC0324 f12">去购买</p>
      </div>
    </div>
    <div class="comment_list" v-if="commentinfo.commentinfo && leaveList">
    <div class="comment_tit">
      <img src="../../assets/images/ly.png"/>
      留言({{commentinfo.commentinfo.comment_nums}})
    </div>
      <div class="list" v-if="leaveList && leaveList.length > 0">
      <div class="pro_comment_item" v-for="(item, index) of leaveList" :key="index">
        <div class="comment_head_info">
          <div class="img">
            <img v-if="item.head" :src="item.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}"/>
            <img v-if="!item.head" :src="errorHeadImg"/>
          </div>
          <div class="info">
            <div class="name">
              {{item.smallname}}
              <img v-if="item.vip_level" :src="`/static/images/vipIcon/l${item.vip_level}.png`"/>
            </div>
            <div class="time">{{item.time}}</div>
          </div>
        </div>
        <div class="comment_content_info">
          <div class="comment_txt">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
      <div v-else style="
        font-size:0.13rem;
        font-weight:400;
        color:rgba(110,110,110,1);
        line-height:0.18rem;
        margin-top: 1.21rem;
        text-align: center;
        ">暂时还没有人留言，快来抢吧～</div>
  </div>
  </Scroller>
  <van-action-sheet v-model="show" title="举报原因" show-action @cancel="show = false">
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell v-for="(item, index) of reportList" :key="index" :title="item.name" clickable @click="reportItemFn(item)">
          <van-radio slot="right-icon" :name="item.id" icon-size="0.18rem" checked-color="#FC0324"/>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="report_btn" :style="radio != null ? {} : {'opacity': '0.45'}" @click="confirm">
      确认
    </div>
  </van-action-sheet>
  <div class="leaveMsg" v-if="commentinfo.commentinfo">
    <div class="inp">
      <img src="../../assets/images/edit.png"/>
      <!--<input placeholder="说点什么…"/>-->
      <textarea class="van-cell" placeholder="说点什么…" v-model="value"></textarea>
      <!--<van-field @focus="submit = true" @blur="submit = false" v-model="value" placeholder="说点什么…" />-->
    </div>
    <div class="btn">
      <!--<div class="msg" v-if="value.length <= 0">-->
        <!--<img src="../../assets/images/ly.png"/>{{commentinfo.commentinfo.comment_nums}}&nbsp;-->
      <!--</div>-->
      <!--v-if="value.length > 0"-->
      <div class="msg" @click="submitComment">
        提交
      </div>
      <div class="zan" @click="commentLike">
      <img :src="commentinfo.commentinfo.islike == 0 ? require('../../assets/images/zan.png') : require('../../assets/images/zan1.png')"/>
        <span class="txt">{{parseInt(commentinfo.commentinfo.like_nums) > 0 ? commentinfo.commentinfo.like_nums : '点赞' }}</span>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import { Rate, ImagePreview } from 'vant'
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ImagePreview)
export default {
  name: 'commentDetail',
  components: {
    [Rate.name]: Rate,
    Scroller
  },
  data () {
    var that = this
    return {
      // submit: false,
      activeIndex: 0,
      bannerSwiper: null,
      commentinfo: {},
      leaveList: [],
      reportList: [],
      isReport: true,
      reportContent: '',
      value: '',
      show: false,
      msg: '',
      bannerList: [],
      radio: null,
      swiperOption: {
        autoplay: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function () {
            // console.log(this.activeIndex) // 切换结束时，告诉我现在是第几个slide
            that.activeIndex = this.activeIndex
          }
        }
      },
      refresh: false,
      loading: false,
      finished: false,
      disabled: true,
      nowPage: 0,
      noDataText: '',
      title: '',
      isVideoImgs:'',
      playShow:true,
      isfullscreen: false,
      showsVideo:false,
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'commentdetail'})
    }
    if (this.$route.query.goodcomment == 1) this.title = this.$route.meta.title = '金粉秀详情'
    let that = this
    that.getData()
    that.nowPage = 1
    that.getLeaveData()
    // that.bannerSwiper = new Swiper('#pro_pic', {
    //   autoplay: true,
    //   observer: true,
    //   observeParents: true,
    //   on: {
    //     slideChangeTransitionStart: function () {
    //       // console.log(this.activeIndex) // 切换结束时，告诉我现在是第几个slide
    //       that.activeIndex = this.activeIndex
    //     }
    //   }
    // })
  },
  methods: {
    playTab(val){
      if(val==0){
        if(this.playShow){
          this.isfullscreen = !this.isfullscreen
           this.$nextTick(()=>{
            if (this.isfullscreen) {
              document.getElementById('videofile').play()
            } else {
              document.getElementById('videofile').pause()
            }
          })
        }else{
         this.playShow = true
         this.isVideoImgs = true
         this.isfullscreen = false
         document.getElementById('videofile').pause()
        }
      }
      if(val==1){
       this.playShow = false
       this.isVideoImgs = false
       document.getElementById('videofile').pause()
      }
    },
    playFn () {
     this.showsVideo = !this.showsVideo
     this.isfullscreen = !this.isfullscreen
     this.$nextTick(()=>{
       if (this.isfullscreen) {
        document.getElementById('videofile').play()
      } else {
        document.getElementById('videofile').pause()
      }
     })

    },
    getData: function () {
      var url = 'Wxmall/Comment/getCommentById?id=' + this.$route.query.commentid
      var that = this
      if (this.$route.query.goodcomment == 1) {
        url += '&isofficia=' + this.$route.query.isofficia
      }
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.commentinfo = res.data
          if(that.commentinfo.commentinfo.video_play_url==""){
            that.isVideoImgs = false
          }else{
            that.isVideoImgs = true
          }
          that.bannerList = []
          for (var i = 1; i < 7; i++) {
            var path = 'path' + i
            if (that.commentinfo.commentinfo[path] != '') {
              that.bannerList.push(that.commentinfo.commentinfo[path])
            }
          }

          that.commentinfo.commentinfo.itemscore = parseInt(res.data.commentinfo.itemscore)
        }
      })
    },
    getLeaveData: function () {
      var url = 'Wxmall/Comment/getLeaveList?id=' + this.$route.query.commentid + '&pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      if (this.$route.query.goodcomment == 1) {
        url += '&isofficia=' + this.$route.query.isofficia
      }
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.leaveList = res.data.leavelist
            that.refresh = false
          } else {
            that.leaveList = that.leaveList.concat(res.data.leavelist)
          }
          that.loading = false
          if (res.data.leavelist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getLeaveData()
      // }, 400)
    },
    commentLike () {
      var url = 'Wxmall/Comment/addCommentLike'
      var data = {
        id: this.$route.query.commentid
      }
      if (this.commentinfo.commentinfo.islike == 0) {
        data.type = 1
      } else if (this.commentinfo.commentinfo.islike == 1) {
        data.type = 2
      }
      if (this.$route.query.goodcomment == 1) {
        data.isofficia = this.$route.query.isofficia
      }
      var that = this
      customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          that.$store.commit('COMMENT_INIT_DATA', 1)
          if (that.commentinfo.commentinfo.islike == 0) {
            that.commentinfo.commentinfo.islike = 1
            that.commentinfo.commentinfo.like_nums = parseInt(that.commentinfo.commentinfo.like_nums) + 1
          } else if (that.commentinfo.commentinfo.islike == 1) {
            that.commentinfo.commentinfo.islike = 0
            that.commentinfo.commentinfo.like_nums = parseInt(that.commentinfo.commentinfo.like_nums) - 1
          }
        }
      })
    },
    submitComment () {
      var url = 'Wxmall/Comment/addCommentLeave'
      var data = {
        id: this.$route.query.commentid,
        content: this.value
      }
      if (this.$route.query.goodcomment == 1) {
        data.isofficia = this.$route.query.isofficia
      }
      this.$ckeckgraphic({
        content: this.value,
        callback: () => {
          var that = this
          if (this.value.replace(/ /g,'') != '') {
            customRequestAjax.post(url, data).then(res => {
              if (res.data.code === 200) {
                that.commentinfo.commentinfo.comment_nums = parseInt(that.commentinfo.commentinfo.comment_nums) + 1
                that.nowPage = 1
                that.getLeaveData()
                this.value = ''
              }
            })
          } else {
            this.$toast('内容不能为空')
          }
        }
      })
    },
    report () {
      this.show = true
      var url = 'Wxmall/Comment/getReportList'
      var that = this
      if (that.isReport) {
        customRequestAjax(url).then(res => {
          if (res.data.code === 200) {
            that.reportList = res.data.list
            that.isReport = false
          }
        })
      }
    },
    reportItemFn (items) {
      this.radio = items.id
      this.reportContent = items.id
    },
    confirm () {
      if (this.radio == null) {
        return
      }
      var url = 'Wxmall/Comment/addLeave'
      var data = {
        id: this.$route.query.commentid,
        reportid: this.reportContent
      }
      var that = this
      customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          that.show = false
          that.$toast('成功举报')
        }
      })
    },
    preview (index) {
      var that = this
      ImagePreview({
        images: that.bannerList,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    goPay () {
      if (this.commentinfo.iteminfo.is_sale == 0) {
        this.$toast('该商品已下架')
      } else {
        this.$router.replace({
          path: '/productdetail',
          query: {
            itemid: this.commentinfo.iteminfo.item_base_id
          }
        })
      }
    }
    // areablur () {
    //   setTimeout(() => {
    //     this.submit = false
    //   })
    // }
  },
}
</script>

<style scoped lang="scss">
  .container.commentdetail {
    background: #fff;
    padding-bottom: .6rem;
    position: relative;
    .maininfo {
      padding-bottom: .22rem;
      .swiper-container {
        .swiper-wrapper {
          margin: 0;
          padding: 0;
          height: 100%;
          .swiper-slide {
            padding: 0;
            margin: 0;
            position: relative;
            img {
              width: 100%;
              display: block;
              border: 0;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -o-transform: translateY(-50%);
            }
          }
        }
        #proSwiperPagination {
          font-size: .12rem;
          width: .34rem;
          color: #fff;
          position: absolute;
          left: auto;
          right: 0.1rem;
          .pro_page{
            position: relative;
            background: url('../../assets/images/pagebg.png') no-repeat center;
            background-size: 100% 100%;
            .swiper-pagination-current{
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top:0;*/
              /*left:0;*/
              /*background: #757575;*/
            }
            .swiper-pagination-split {
              margin-left: .02rem;
              margin-right: .02rem;
              /*position: absolute;*/
              /*top:0;*/
              left:.08rem;
              height: .12rem;
              line-height: .12rem;
              margin-top: .01rem;
              /*background: #757575;*/
              text-align: center;
              font-size: .12rem;
              transform: scale(0.8);
            }
            .swiper-pagination-total{
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top:0;*/
              left:.14rem;
              /*background: #757575;*/
            }
          }

        }
      }
      .swiper_bottom_div{
        width: 100%;
        font-size: 0.12rem;
        text-align: center;
        position: absolute;
        left: 0;
        bottom: 0.05rem;
        z-index: 999;
        .span_btn{
          display: inline-block;
          width: 0.5rem;
          height: 0.25rem;
          line-height: 0.23rem;
          text-align: center;
          background: #f9f9f9;
          border-radius: 0.2rem;
          border: 0.01rem solid #e0e1e0;
          font-size: .12rem;
          font-weight: 400;
          color: #353535;
          margin: 0 0.05rem;
        }
        .span_btnSelect{
          display: inline-block;
          width: 0.5rem;
          height: 0.25rem;
          line-height: 0.23rem;
          text-align: center;
          border-radius: 0.2rem;
          font-size: .12rem;
          font-weight: 400;
          background: linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
           border: 0.01rem solid transparent;
           color: #FFFFFF;
           margin: 0 0.05rem;
        }
      }
      .pro_comment_item{
        padding: 0 .11rem;
        margin-top: .2rem;
        .comment_head_info{
          position: relative;
          overflow: hidden;
          padding-bottom: 0.1rem;
          .sj{
            position: absolute;
            right:0;
            top:0;
            z-index:9;
            font-size: .12rem;
            .van-icon-star{
              font-size: .13rem;
            }
          }
          .report{
            position: absolute;
            top:.08rem;
            right:0;
            font-size: .13rem;
            color:#191818;
            margin-top: 0.1rem;
            img{
              width: .1rem;
              height: .12rem;
              display: inline-block;
             /*vertical-align: middle;*/
              margin-right: .02rem;
            }
          }
          .img{
            width: .37rem;
            float: left;
            img{
              width: .37rem;
              height: .37rem;
              border-radius: .37rem;
            }
          }
          .info{
            float: left;
            position: relative;
            .name{
              font-size: .14rem;
              line-height: .2rem;
              padding-left: .1rem;
              width: 2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              img{
                width: .3rem;
                height: .14rem;
                display: inline-block;
                vertical-align: middle;
              }
            }

            .time{
              font-size: .12rem;
              transform: scale(0.85);
              color:#AFB0AF;
              margin-left: -0.05rem;
            }
          }
        }
        .comment_content_info{
          padding-left: .47rem;
          .comment_txt{
            font-size: .14rem;
            line-height: .2rem;
            color:#6D6D6D;
            word-break: break-word;
            .isfeedback {
              border-radius: 0.02rem;
              border: 0.01rem solid #FC0324;
              margin-right: 0.02rem;
            }
          }
        }
      }
    }
    .commentProduct {
      padding: 0.1rem 0.11rem;
      border-top: solid .1rem #F5F5F5;
      /*background: #fff;*/
      /*height: 0.4rem;*/
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -o-justify-content: space-between;
      -ms-justify-content: space-between;
      .left {
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        height: 0.4rem;
        img {
          width: 0.3rem;
          height: 0.3rem;
          vertical-align: bottom;
        }
        p {
          font-size:0.13rem;
          font-weight:400;
          color:rgba(41,41,41,1);
          /*line-height:0.3rem;*/
          margin-left: 0.1rem;
          margin-right: 0.06rem;
        }
        i {
          max-width: 0.72rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size:0.11rem;
          font-weight:400;
          color:rgba(153,153,153,1);
          /*line-height:0.3rem;*/
          font-style: normal;
        }
      }
      .right {
        height: 0.4rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        img {
          width: 0.16rem;
          height: 0.16rem;

        }
        p {
          font-weight:400;
          border: 0.005rem solid #FC0324;
          border-radius: 0.135rem;
          width: 0.7rem;
          height: 0.27rem;
          text-align: center;
          line-height: 0.265rem;
        }
      }
    }
    .comment_list{
      border-top:solid .1rem #F5F5F5;
      padding-bottom: 0.6rem;
      .comment_tit{
        height: .41rem;
        line-height: .41rem;
        border-bottom: solid 0.01rem rgba(239,239,239,1);
        margin: 0 .11rem;
        font-size: .13rem;
        color:#6D6D6D;
        display: flex;
        align-items: center;
        img{
          width: .25rem;
          height: .25rem;
          display: block;
          margin-right: .07rem;
        }
      }
      .list{
        .pro_comment_item{
          padding: 0 .11rem;
          margin-top: .2rem;
          .comment_head_info{
            position: relative;
            overflow: hidden;
            .img{
              width: .37rem;
              float: left;
              img{
                width: .37rem;
                height: .37rem;
                border-radius: .37rem;
              }
            }
            .info{
              float: left;
              position: relative;
              .name{
                font-size: .14rem;
                line-height: .2rem;
                padding-left: .1rem;
                img{
                width: .3rem;
                height: .14rem;
                display: inline-block;
                vertical-align: middle;
              }
              }

              .time{
                font-size: .12rem;
                transform: scale(0.85);
                color:#AFB0AF;
                margin-left: .05rem;
              }
            }
          }
          .comment_content_info{
            padding-left: .47rem;
            .comment_txt{
              font-size: .14rem;
              line-height: .2rem;
              color:#6D6D6D;
              word-break: break-word;
            }
          }
        }
      }
    }
    .leaveMsg{
      position: fixed;
      bottom: 0;
      left:0;
      width: 100%;
      height: .43rem;
      border-top:solid 0.01rem rgba(0,0,0,0.25);
      z-index: 9;
      background: #fff;
      padding: 0 .11rem;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -o-justify-content: space-between;
      -ms-justify-content: space-between;
      .inp{
        /*width: 2.11rem;*/
        background: #F5F5F5;
        height: .29rem;
        display: flex;
        align-items: center;
        font-size: .13rem;
        border-radius: .15rem;
        color:#999999;
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        -o-flex: 1;
        input{
          border:0;
          background: #F5F5F5;
          color:#292929;
        }
        img{
          width: .2rem;
          height: .2rem;
          margin-left: .1rem;
          margin-right: .05rem;
          pointer-events:none;
          -webkit-user-select: none;
          -webkit-touch-callout: none;
          word-break: break-word;
        }
      }
      .btn {
        display: flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -ms-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
      }
      .msg{
        float: left;
        display: flex;
        align-items: center;
        margin-left: .1rem;
        font-size: .14rem;
        padding: 0.05rem;
        color: #4a90e2;
        img{
          width: .22rem;
          height: .19rem;
          margin-right: .09rem;
        }
      }
      .zan{
        float: right;
        display: flex;
        align-items: center;
        margin-left: .11rem;
        font-size: .13rem;
        img{
          width: .22rem;
          height: .19rem;
          margin-right: .05rem;
        }
        .txt{
          color:#6D6D6D;
        }
      }
    }
    .van-popup {
      .van-action-sheet__header {
        position: static;
        .van-action-sheet__close {
          background: url('../../assets/images/closex.png') no-repeat center;
          background-size: 0.2rem 0.2rem;
          padding-right: .21rem;
        }
      }
      .van-action-sheet__content {
        .van-hairline--top-bottom {
          position: static;
        }
        .van-cell {
          position: static;
        }
        .van-radio__icon--round .van-icon{
          border-radius: 1.25rem;
        }
      }
    }
    .report_btn{
      width:3.53rem;
      height:.43rem;
      background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
      border-radius:.25rem;
      text-align: center;
      font-size: .17rem;
      color:#fff;
      line-height: .43rem;
      margin: .1rem auto;
      margin-top: .2rem;
      /*position: fixed;*/
      /*left: 0;*/
      /*right: 0;*/
      /*bottom: 0;*/
      span{
        font-size: .13rem;
      }
    }
  }
</style>
<style lang="scss">
  .leaveMsg {
    .van-cell {
      line-height: 0.29rem;
      background-color: transparent;
      width: 82%;
      padding: 0;
      height: 0.29rem;
      border: 0;
      outline: none;
      overflow-y: auto;
      &::placeholder {
        line-height: 0.29rem;
      }
    }
  }
  .commentdetail {
    .van-dialog__header {
      padding-bottom: 0.15rem;
      border-bottom: 0.01rem solid #EFEFEF;
      margin: 0 0.15rem 0.09rem;
    }
    .van-dialog__content {
      padding-top: 0.17rem;
      margin: 0 0.15rem 0.13rem;
      height: 2.12rem;
      overflow-y: auto;
      .van-radio-group {
        .van-cell-group {
          position: static;
          .van-cell {
            position: static;
            padding: 0;
            margin-bottom: 0.2rem;
            &:last-of-type {
              margin-bottom: 0;
            }
            .van-radio {
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productdetail/commentDetail.vue